// @flow
import * as React from 'react';
import MediaQuery from 'react-responsive';
import LoginDesktop from './LoginDesktop';
import LoginMobile from './LoginMobile';

type Props = {
  userName: string,
  password: string,
  errors: Array<string>,
  onChange: (SyntheticKeyboardEvent<HTMLInputElement>) => mixed,
  onClickForgottenPassword: () => void,
  onSubmit: (SyntheticEvent<HTMLButtonElement>) => mixed
};

const companyName = process.env.REACT_APP_COMPANY_NAME;

const LoginPageDisplay = React.memo<Props>((props: Props) => (
  <>
    <MediaQuery maxWidth={575.98}>
      <LoginMobile {...props} companyName={companyName} />
    </MediaQuery>
    <MediaQuery minWidth={576}>
      <LoginDesktop {...props} companyName={companyName} />
    </MediaQuery>
  </>
));

export default LoginPageDisplay;
